<div class="content-radio" *ngIf="radios && (radios.length > 0)">
    <div class="row drop-container">
        <div class="col-md-5 center">
            <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{texto}}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" *ngIf='radios'>
                    <button class="dropdown-item" (click)="verifyRadioOption('fm96.1')">{{radios[2].name}}</button>
                    <button class="dropdown-item" (click)="verifyRadioOption('universal')">
                        {{radios[0].name}}</button>
                    <button class="dropdown-item" (click)="verifyRadioOption('am24.7')">{{radios[1].name}}z</button>
                </div>
            </div>
        </div>
        <div class="col-md-7 p-0">
            <div class="d-flex justify-content-around actions">
                <div class="buttons-cont">
                    <button mat-button (click)="pause()" *ngIf="radiosDataService.PLAYLISTONOFF">
                        <mat-icon [ngStyle]="{'color':'white'}" aria-hidden="false" aria-label="Example pause icon">
                            pause</mat-icon>
                    </button>
    
                    <button mat-button *ngIf="!radiosDataService.PLAYLISTONOFF" (click)="verifyRadioToPlay()">
                        <mat-icon [ngStyle]="{'color':'white'}" aria-hidden="false" aria-label="Example pause icon">
                            play_arrow</mat-icon>
                    </button>
    
                    <button mat-button [matMenuTriggerFor]="menu">
                        <mat-icon [ngStyle]="{'color':'white'}" aria-hidden="false" aria-label="Example volume_up icon">
                            volume_up</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <mat-slider vertical='false' [(ngModel)]="value" #mySlider
                            (slideend)="sliderOnChange(mySlider.value)" (pointerup)="sliderOnChange(mySlider.value)">
                        </mat-slider>
                    </mat-menu>
                </div>
    
                <div *ngIf="radioFM961 && radios">
                    <div class="d-flex">
                        <img class="radio-portada" height="85px" width="100px" [src]="radios[2].image" [alt]="radios[2].name">
                        <div class="radio-name">
                            <p>{{ radios[2].name }}</p>
                        </div>
                    </div>
                </div>

                <div *ngIf="radioUniversal && radios">
                    <div class="d-flex">
                        <img height="85px" width="100px" [src]="radios[0].image" [alt]="radios[0].name">
                        <div class="radio-name">
                            <p>{{ radios[0].name }}</p>
                        </div>
                    </div>
                </div>

                <div *ngIf="radioAM247 && radios">
                    <div class="d-flex">
                        <img height="85px" width="100px" [src]="radios[1].image" [alt]="radios[1].name">
                        <div class="radio-name">
                            <p>{{ radios[1].name }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>